require('./bootstrap');
import 'dropzone/dist/dropzone.css';
import Dropzone from 'dropzone/dist/dropzone.js';

const { general } = require('./_general');
const { quotes } = require('./_quotes');
const { quotesModal } = require('./_quotes-modal');
const { schedule } = require('./_schedule');
const { customer } = require('./_customer');
const { projectGroups } = require('./_project-groups');

window.Dropzone = Dropzone;
const { uploads } = require('./_uploads'); 

// Import and make Toastr globally accessible
import 'toastr/build/toastr.min.css';
import toastr from 'toastr';
window.toastr = toastr;